export default __webpack_public_path__ + "static/chmervideo-comp-442fd6dcad108b95be962fa0a1ce3ad2.mp4";